import useSWR from "swr";
import { PROXY } from "../lib/utils";

const fetcher = async (url) => {
  const response = await fetch(url);

  if (!response.ok) {
    const error = new Error("Failed to fetch categories");
    error.status = response.status;

    try {
      error.info = await response.json();
    } catch {
      error.info = null;
    }

    throw error;
  }

  return response.json();
};

export default function useCategories(query = "") {
  const normalizedQuery = query && !query.startsWith("?") ? `?${query}` : query;

  const { data, error, isLoading, mutate } = useSWR(
    `${PROXY}/categories${normalizedQuery}`,
    fetcher,
    {
      revalidateOnFocus: false,
      dedupingInterval: 60_000,
    },
  );

  return {
    data: Array.isArray(data) ? data : [],
    error,
    isLoading,
    mutate,
  };
}
